import { atom, useAtomValue, useSetAtom } from 'jotai';

const flyoutNavigationStatusAtom = atom(false);

export const useFlyoutNavigation = () => {
  const flyoutNavigationOpen = useAtomValue(flyoutNavigationStatusAtom);
  const updateFlyoutNavigationStatus = useSetAtom(flyoutNavigationStatusAtom);

  return {
    flyoutNavigationOpen,
    updateFlyoutNavigationStatus,
  };
};
